import { useCollection } from 'src/hooks/databaseHooks';

const useEsgSurveyResponsesStandalone = ({ orgId = "none", periodId = "none", isStandalone }) => {

    let entriesPath
    if (isStandalone) {
        entriesPath = ["esg-survey", orgId, "entries"]
    } else {
        entriesPath = ["organisations", orgId, "periods", periodId, "details", "assessment-survey", "entries"]
    }

    const { data: surveyResponses = [], status } = useCollection(entriesPath);

    const externalSurveyResponses = surveyResponses.filter(
        (entry) => entry.id !== "self" && entry.id !== "admin"
    );
    const internalSurveyResponses = surveyResponses.find((entry) => entry.id === "self") || {};
    const adminSurveyResponses =
        surveyResponses.find((entry) => entry.id === "admin") || {};


    const totalSurveyResponses = surveyResponses.length;

    return { totalSurveyResponses, externalSurveyResponses, internalSurveyResponses, adminSurveyResponses, status }
}

export default useEsgSurveyResponsesStandalone